/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sso_Loading_OrganizationsInputs */



/**
* | output |
* | --- |
* | "Loading organizations..." |
*
* @param {Auth_Sso_Loading_OrganizationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_loading_organizations = /** @type {((inputs?: Auth_Sso_Loading_OrganizationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_Loading_OrganizationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisationen werden geladen...")
	return /** @type {LocalizedString} */ ("Loading organizations...")
});